import React from "react";
import "./Achievements.css";

const Achievements = () => {
  return (
    <div className="achievements-div">
      <h1 className="achievements-title">Career Highlights</h1>

      <div className="achievement-grid">
<div className="achievement-card">
  <h2>3+</h2>
  <p>Years Experience</p>
</div>

<div className="achievement-card">
  <h2>WebMD</h2>
  <p>Software Engineer</p>
</div>

<div className="achievement-card">
  <h2>5+</h2>
  <p>Projects Delivered</p>
</div>

<div className="achievement-card">
  <h2>1</h2>
  <p>Published Play Store App</p>
</div>

        
      </div>
    </div>
  );
};

export default Achievements;